<template>
  <div more>
    <div more-inner>
      <div more-padding>
        <a><s>View More</s><Icon name="more"/></a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/views/components/Icon';
export default {
  name: 'More',
  components: { Icon },
};
</script>

<style lang="less">
@import "~@/less/proj";
[more] { .p(0,20); .mt(60);
  [more-inner] { .rel;
    a { .block; .-a(#878d96); .tc; .p(16); .bgc(#f7f8fb);
      s { .calibre; .vam; .cal-m; .fs(20); .medium; .lh(22); }
      [icon] { .ml(10); }
    }
  }
}
@media (min-width: @screen-md-min) {
  [more] { .p(0,21); .mt(80);
    [more-inner] { .tc;
      [more-padding] { .ib; .w(50%); .p(0,9); .-box; }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [more] { .p(0,25); .mt(70);
    [more-inner] {
      [more-padding] { .w(33.333%); .p(0, 15); }
    }
  }
}

@media (min-width: @screen-xl-min) {
  [more] { .p(0,20); .w(1320); .mh-c; .mt(80);
    [more-inner] {
      [more-padding] { .p(0, 20); }
    }
  }
}

</style>
